import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class formForgotPassword {
	static classname = 'form-forgot-password';

	constructor($form) {
		this.$form = $form;
		this.decorate();
		this.init();
		this.bindEvents();
	}

	init = () => {
		this.is_disabled_button = true;
	};

	decorate = () => {
		this.$form.find('.wa-forgotpassword-button').append(
			'<button type="submit" class="form__btn btn btn--green">Восстановить пароль</button>');
	};

	bindEvents = () => {
		this.$input.on('input', () => {
			this.is_disabled_button = !this.$input.val();
		});

		$(document).ajaxSuccess((event, xhr, settings, data) => {
			if (settings.url === '/forgotpassword/' && data["status"] === 'ok') {
				this.$form.find('.wa-info-msg')
					.html(`Cообщение со ссылкой для восстановления пароля отправлено на адрес
					 		<strong>${data["data"]["address"]}</strong>.`)
					.css({display: 'block'});
			}
		});
	};

	set is_disabled_button(state) {
		this.$button.toggleClass('btn--disabled', state);
	}

	get $button() {
		return this.$form.find('.form__btn');
	}

	get $input() {
		return this.$form.find('input[name="login"]');
	}

}
